var React = require('react');

function IconFocusImpact (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M52.8 54C52.5 54 52.2 53.9 52 53.7L42.2 43.9C41.7 43.4 41.7 42.7 42.2 42.2C42.4 42 42.7 41.9 43 41.9C43.3 41.9 43.6 42 43.8 42.2L53.6 52C54.1 52.5 54.1 53.2 53.6 53.7C53.4 53.9 53.1 54 52.8 54ZM22.1 44.2C9.9 44.2 0 34.3 0 22.1C0 9.9 9.9 0 22.1 0C34.3 0 44.2 9.9 44.2 22.1C44.2 34.3 34.3 44.2 22.1 44.2ZM22.1 2.4C11.2 2.4 2.4 11.2 2.4 22.1C2.4 33 11.2 41.8 22.1 41.8C33 41.8 41.8 33 41.8 22.1C41.8 11.2 32.9 2.4 22.1 2.4Z","fill":"#00D664","key":0}),React.createElement("path",{"d":"M32 15L19.3333 29.6667L12 23","stroke":"#DDDDDD","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

IconFocusImpact.defaultProps = {"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none"};

module.exports = IconFocusImpact;

IconFocusImpact.default = IconFocusImpact;
